function Undo({ size }: { size: number }) {
  return (
    <svg height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.675 7.28776H5.09473L8.32498 4.059L7.26148 3L3.54898 6.71176C3.19747 7.06337 3 7.5402 3 8.03738C3 8.53457 3.19747 9.01139 3.54898 9.36301L7.26148 13.0763L8.32498 12.0158L5.09998 8.79076H18.675C18.8786 8.7771 19.0794 8.84423 19.2338 8.9776C19.3882 9.11098 19.4839 9.29984 19.5 9.50326V17.8283C19.4837 18.0316 19.388 18.2202 19.2336 18.3534C19.0791 18.4867 18.8785 18.5537 18.675 18.54H4.49998V20.04H18.675C19.2767 20.0539 19.8593 19.8287 20.2952 19.4136C20.731 18.9986 20.9845 18.4277 21 17.826V9.50026C20.9841 8.89888 20.7304 8.32833 20.2946 7.91362C19.8588 7.49891 19.2764 7.27385 18.675 7.28776Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default Undo
